document.addEventListener("DOMContentLoaded", function () {
                const addToCartButton = document.querySelector('form[action$="/cart/add"] button[type="submit"]');
                const addExtraButton = document.querySelector('.product-add-extra-button');
                const extraProductCheckbox = document.querySelector("#add-extra-product");
    
  if(addExtraButton){
                addToCartButton.style.display = "none";
  }
                if (!addExtraButton || !extraProductCheckbox) return;
              
                addExtraButton.addEventListener("click", function (event) {
                  if (!extraProductCheckbox.checked) return; // Proceed normally if the checkbox isn't checked
              
                  event.preventDefault(); // Prevent form submission initially
              
                  const additionalProductId = extraProductCheckbox.dataset.productId;
                  if (!additionalProductId) return;
              
                  // Add additional product (warranty) to cart first
                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    body: JSON.stringify({ id: additionalProductId, quantity: 1 }),
                    headers: { "Content-Type": "application/json" },
                  })
                    .then((response) => response.json())
                    .then((response) => {
                      if (response.status) {
                        console.error("Error adding warranty product:", response);
                        return;
                      }
              
                      // After adding additional product, resume form submission
                      addToCartButton.click();
                      setTimeout(checkAndToggleExtraProduct, 1000);
                    })
                    .catch((error) => console.error("Error adding to cart:", error));
                });
            });
document.addEventListener("DOMContentLoaded", function () {
              const addPppButton = document.querySelector(".add-ppp-btn");
              const extraProductCheckbox = document.querySelector("#add-extra-product");
              const closeButton = document.querySelector("#dialog-close");
              const thanksButton = document.querySelector(".no-thank-option");
              const warrantyModal = document.querySelector(".warranty-modal");
            
              if (addPppButton && extraProductCheckbox) {
                addPppButton.addEventListener("click", function (event) {
                  event.preventDefault();
                  extraProductCheckbox.checked = true;
                  warrantyModal.style.display = "none";
                });
              }
            
              if (closeButton) {
                closeButton.addEventListener("click", function (event) {
                  event.preventDefault();
                  extraProductCheckbox.checked = false;
                  warrantyModal.style.display = "none";
                });
              }
              if (thanksButton) {
                thanksButton.addEventListener("click", function (event) {
                  event.preventDefault();
                  extraProductCheckbox.checked = false;
                  warrantyModal.style.display = "none";
                });
              }
            });


  
document.addEventListener("DOMContentLoaded", function () {
  // Select all instances of the price-range component on the page
  document.querySelectorAll(".price-range").forEach(function (priceRange) {
    // Select elements specific to this instance of the price range
    var inputFromLabel = priceRange.querySelector(
      ".price-range-label .field__label[for=From]"
    );
    var inputToLabel = priceRange.querySelector(
      ".price-range-label .field__label[for=To]"
    );
    var inputFromRange = priceRange.querySelector(
      'input[type="range"][aria-label="From"]'
    );
    var inputToRange = priceRange.querySelector(
      'input[type="range"][aria-label="To"]'
    );
    var inputFromNumber = priceRange.querySelector(
      '.price-range__input input[name="filter.v.price.gte"]'
    );
    var inputToNumber = priceRange.querySelector(
      '.price-range__input input[name="filter.v.price.lte"]'
    );
    var rangeGroup = priceRange.querySelector(".price-range__range-group");

    function updateRangeGroup() {
      var minPercent =
        ((inputFromRange.value - inputFromRange.min) /
          (inputFromRange.max - inputFromRange.min)) *
        100;
      var maxPercent =
        ((inputToRange.value - inputToRange.min) /
          (inputToRange.max - inputToRange.min)) *
        100;

      rangeGroup.style.setProperty(
        "--range-min",
        `${Math.min(minPercent, 100)}%`
      );
      rangeGroup.style.setProperty(
        "--range-max",
        `${Math.min(maxPercent, 100)}%`
      );
    }

    function syncInputs(sourceInput, targetInput, targetLabel) {
      targetInput.value = sourceInput.value;
      if (targetLabel)
        targetLabel.innerText = "$" + parseInt(sourceInput.value).toString(); // Removes decimals
      updateRangeGroup();
    }

    function enforceRangeLogic() {
      if (parseFloat(inputFromRange.value) > parseFloat(inputToRange.value)) {
        inputFromRange.value = inputToRange.value;
        syncInputs(inputFromRange, inputFromNumber, inputFromLabel);
      }
    }

    // Add event listeners for this specific instance
    if (inputFromRange && inputToRange && inputFromNumber && inputToNumber) {
      // From range input change
      inputFromRange.addEventListener("input", function () {
        syncInputs(this, inputFromNumber, inputFromLabel);
        enforceRangeLogic();
      });

      // To range input change
      inputToRange.addEventListener("input", function () {
        syncInputs(this, inputToNumber, inputToLabel);
        enforceRangeLogic();
      });

      // Number input change (From)
      inputFromNumber.addEventListener("input", function () {
        inputFromRange.value = this.value;
        syncInputs(this, inputFromRange, inputFromLabel);
        enforceRangeLogic();
      });

      // Number input change (To)
      inputToNumber.addEventListener("input", function () {
        inputToRange.value = this.value;
        syncInputs(this, inputToRange, inputToLabel);
        enforceRangeLogic();
      });
    }

    // Initialize the visual state for each component
    updateRangeGroup();
  });
});


  document.addEventListener("DOMContentLoaded", function () {
    const checkoutBtn = document.getElementById("promo_btn");
    const promoInput = document.getElementById("promo_code");

    if (checkoutBtn && promoInput) {
      checkoutBtn.addEventListener("click", function (e) {
        e.preventDefault(); // prevent default form submission
        const code = promoInput.value.trim();

        // Build checkout URL with discount
        let checkoutUrl = "/checkout";
        if (code) {
          checkoutUrl += "?discount=" + encodeURIComponent(code);
        }

        // Redirect to checkout
        window.location.href = checkoutUrl;
      });
    }
  });

   document.addEventListener("DOMContentLoaded", function() {
    var acc = document.getElementsByClassName("custom_ac-trigger");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.height) {
                panel.style.height = null;
            } else {
                panel.style.height = panel.scrollHeight + "px";
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('mouseover', function(e) {
    if (e.target instanceof Element) {
      var colorOption = e.target.closest('.color-swatch .color-option');
      if (colorOption) {
        var vimage = colorOption.getAttribute('data-image');
        var productCard = colorOption.closest('.product-card-wrapper').querySelector('.card .card__inner .card__media img:first-child');
        if (productCard) { productCard.src = vimage; productCard.srcset = vimage; }
      }
    }
  });
  document.addEventListener('mouseleave', function(e) {
    if (e.target instanceof Element) {
      var colorOption = e.target.closest('.color-swatch .color-option');
      if (colorOption) {
        var mimage = colorOption.getAttribute('data-mainimage');
        var productCard = colorOption.closest('.product-card-wrapper').querySelector('.card .card__inner .card__media img:first-child');
        if (productCard) { productCard.src = mimage; productCard.srcset = mimage; }
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {  
 
  });

  document.addEventListener('DOMContentLoaded', function() {
    var ac = document.getElementsByClassName("ac-trigger1");
   var j;

 for (j = 0; j < ac.length; j++) {
  ac[j].addEventListener("click", function() {
    this.classList.toggle("active");
    var panell = this.nextElementSibling;
    if (panell.style.height) {
      panell.style.height = null;
    } else {
      panell.style.height = panel.scrollHeight + "px";
    } 
  });
}
    });